import { Icon } from '@eventbrite/eds-icon';
import React from 'react';
import { NestedDropdownItemProps } from '../../../../types';
import { SimpleDropdownItem } from '../SimpleDropdownItem';
import styles from './NestedDropdownItem.module.scss';

const NestedDropdownItem = ({
    iconType,
    text,
    subItems,
}: NestedDropdownItemProps) => {
    console.log(styles);
    return (
        <div className={styles.nestedDropdownItem} tabIndex={0}>
            <div className={styles.nestedDropdownTrigger} tabIndex={0}>
                {iconType ? (
                    <span className={styles.iconContainer}>
                        <Icon type={iconType} />
                    </span>
                ) : null}
                <span className="dropdown-item__title nested-dropdown-trigger">
                    {text}
                </span>
            </div>
            <div className={styles.submenu} tabIndex={0} aria-label="submenu">
                {subItems?.map((props) => (
                    <SimpleDropdownItem
                        {...props}
                        key={props.text.toString()}
                    />
                ))}
            </div>
        </div>
    );
};

export default NestedDropdownItem;
